import '@fontsource/inter'

const styles = () => ({
  firstGridItem: {
    marginBottom: '4px !important',
  },

  messageTypography: {
    fontFamily: 'Inter !important',
    fontStyle: 'normal !important',
    fontWeight: '400 !important',
    fontSize: '16px !important',
    lineHeight: '24px !important',
    color: '#667085 !important',
  },

  titleTypography: {
    fontFamily: 'Inter !important',
    fontStyle: 'normal !important',
    fontWeight: '500 !important',
    fontSize: '30px !important',
    lineHeight: '38px !important',
    color: '#101828 !important',
  },
})

export default styles
